export default __webpack_public_path__ + "static/media/step1.3bdd6df3.svg";